// extracted by mini-css-extract-plugin
export default {"modal":"Pca-z","modalContent":"Qca-z","footer":"Rca-z","cancelBtn":"Sca-z","disabled":"Tca-z","formWrapper":"Uca-z","fade":"Vca-z","fade-in":"Wca-z","iframe":"Xca-z"};